export default "__VITE_ASSET__d9e135b2__"